import moment from 'moment'

const LastEditedCell = () => {
  return ({ last_edited_timestamp, last_edited_by }) => {
    return (
      last_edited_timestamp
        ? moment(last_edited_timestamp * 1000).format('DD-MMM-YY HH:mm') + ' by ' + last_edited_by
        : null
    )
  }
}

export default LastEditedCell
